import { apiClient } from '@/shared/api';
import type {
  UserUrlLogClearParams,
  UserUrlLogCreate,
  UserUrlLogDeleteResponse,
  UserUrlLogListParams,
  UserUrlLogListResponse,
} from './types';

// Реэкспорт типов для удобства импорта из одного модуля
export type {
  UserUrlLogClearParams,
  UserUrlLogCreate,
  UserUrlLogDeleteResponse,
  UserUrlLogListParams,
  UserUrlLogListResponse,
};

/**
 * Сохраняет запись о переходе текущего пользователя на URL (POST /user-url-log).
 * Best-effort: ошибки записи на бэкенде не возвращаются (всегда 201), вызов выполняется fire-and-forget.
 * silentError подавляет всплывающие уведомления, чтобы сбой логирования не влиял на UI.
 */
export const createUserUrlLog = async (payload: UserUrlLogCreate): Promise<void> => {
  await apiClient.post('/user-url-log', payload, { silentError: true });
};

/**
 * Возвращает список записей лога URL с фильтрацией и пагинацией (GET /user-url-log).
 * Требует разрешения VIEW_USER_LOG.
 */
export const fetchUserUrlLog = async (params?: UserUrlLogListParams): Promise<UserUrlLogListResponse> => {
  const { data } = await apiClient.get<UserUrlLogListResponse>('/user-url-log', { params });
  return data;
};

/**
 * Удаляет записи лога URL старше указанного момента (DELETE /user-url-log).
 * Требует разрешения ADMIN_USER_LOG. Возвращает число удалённых записей.
 */
export const clearUserUrlLog = async (params: UserUrlLogClearParams): Promise<UserUrlLogDeleteResponse> => {
  const { data } = await apiClient.delete<UserUrlLogDeleteResponse>('/user-url-log', { params });
  return data;
};
